const normalizedStatus = (status) => String(status || '').trim().toLowerCase().replace(/[_\s]+/g, '-');

const progress = (label, status, current, steps, isError = false) => ({
  label,
  status: String(status || ''),
  current,
  steps,
  isError,
});

export const getLinenProgress = (status) => {
  const key = normalizedStatus(status || 'Scheduled');
  const steps = ['Scheduled', 'En-route', 'Completed', 'Collected'];
  const indices = {
    scheduled: 0,
    'en-route': 1,
    'on-route': 1,
    completed: 2,
    collected: 3,
  };

  return progress(
    'Linen progress',
    status || 'Scheduled',
    indices[key] ?? 0,
    steps,
    ['cancelled', 'canceled', 'failed'].includes(key),
  );
};

export const getCleaningProgress = (status) => {
  if (!String(status || '').trim()) return null;

  const key = normalizedStatus(status);
  const steps = ['Pending', 'Scheduled', 'In progress', 'Completed'];
  const indices = {
    pending: 0,
    unassigned: 0,
    scheduled: 1,
    assigned: 1,
    'en-route': 2,
    'on-route': 2,
    'in-progress': 2,
    completed: 3,
    done: 3,
  };

  return progress(
    'Cleaning progress',
    status,
    indices[key] ?? 0,
    steps,
    ['cancelled', 'canceled', 'failed'].includes(key),
  );
};

export const getIndependentOrderProgress = (order) => ({
  linen: getLinenProgress(order?.order_status),
  cleaning: getCleaningProgress(order?.cleaning_status),
});
